const works = [
  {
    id: 0,
    title: 'RZS Abogados',
    url: 'https://www.rzs.es/',
    image: 'rzs.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
      { icon: ['fab', 'elementor'], name: 'elementor', isIcon: true },
    ],
    description: 'rzs',
  },
  {
    id: 1,
    title: 'El defensor de tu vivienda',
    url: 'https://www.eldefensordetuvivienda.com',
    image: 'edv.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
      { icon: ['fab', 'elementor'], name: 'elementor', isIcon: true },
    ],
    description: 'edv',
  },
  {
    id: 2,
    title: 'Runnics',
    url: 'https://www.runnics.com/',
    image: 'runnics.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
      { icon: ['fab', 'elementor'], name: 'elementor', isIcon: true },
    ],
    description: 'runnics',
  },
  {
    id: 3,
    title: 'Honimunn',
    url: 'https://honimunn.com/',
    image: 'honimunn.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
      { icon: ['fab', 'elementor'], name: 'elementor', isIcon: true },
    ],
    description: 'honimunn',
  },
  {
    id: 4,
    title: 'Performanze',
    url: 'https://performanze.io/',
    image: 'performanze.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
      { icon: ['fab', 'elementor'], name: 'elementor', isIcon: true },
    ],
    description: 'performanze',
  },
  {
    id: 5,
    title: 'DNA Testing San Francisco',
    url: 'https://dnatestingsanfrancisco.com/',
    image: 'dnatestingsanfrancisco.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
      { icon: ['fab', 'elementor'], name: 'elementor', isIcon: true },
    ],
    description: 'dna',
  },
  {
    id: 6,
    title: 'DNA Testing Anaheim',
    url: 'https://dnatestinganaheim.com/',
    image: 'dnatestinganaheim.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
      { icon: ['fab', 'elementor'], name: 'elementor', isIcon: true },
    ],
    description: 'dna',
  },
  {
    id: 7,
    title: 'Blog TheDigitalWay',
    url: 'https://blog.thedigitalway.education/',
    image: 'blogthedigitalway.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
    ],
    description: 'blogtdw',
  },
  {
    id: 8,
    title: 'Ofituria',
    url: 'https://ofituria.com/',
    image: 'ofituria.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
      { icon: ['fab', 'elementor'], name: 'elementor', isIcon: true },
    ],
    description: 'ofituria',
  },
  {
    id: 9,
    title: 'Akron',
    url: '#',
    image: 'akron.jpeg',
    icons: [
      { icon: ['fab', 'laravel'], name: 'laravel', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
    ],
    description: 'akron',
  },
  {
    id: 10,
    title: 'Jorge Silva',
    url: '#',
    image: 'jorgesilva.jpeg',
    icons: [
      { icon: ['fab', 'laravel'], name: 'laravel', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
    ],
    description: 'jorgesilva',
  },
  {
    id: 11,
    title: 'Paypal Calculate Feed',
    url: 'https://paypal-calculator-feed.netlify.app/',
    image: 'paypalfeed.png',
    icons: [
      { icon: ['fab', 'vuejs'], name: 'vue', isIcon: true },
      { icon: ['fab', 'js'], name: 'js', isIcon: true },
      { name: 'tailwindcss', isIcon: false, image: 'tailwindcss.png' },
    ],
    description: 'paypalcf',
  },
  {
    id: 12,
    title: 'Pokedex',
    url: 'https://pokedex-varcast.netlify.app/',
    image: 'pokedex.png',
    icons: [
      { icon: ['fab', 'vuejs'], name: 'vue', isIcon: true },
      { icon: ['fab', 'js'], name: 'js', isIcon: true },
      { name: 'tailwindcss', isIcon: false, image: 'tailwindcss.png' },
    ],
    description: 'pokedex',
  },
  {
    id: 13,
    title: 'Github Users',
    url: 'https://github-users-consult.netlify.app/',
    image: 'githubuser.png',
    icons: [
      { icon: ['fab', 'vuejs'], name: 'vue', isIcon: true },
      { icon: ['fab', 'js'], name: 'js', isIcon: true },
      { name: 'tailwindcss', isIcon: false, image: 'tailwindcss.png' },
    ],
    description: 'githubuser',
  },
  {
    id: 14,
    title: 'Platzi Exchange',
    url: 'https://platzi-exchange-varcast.netlify.app/',
    image: 'platziexchange.png',
    icons: [
      { icon: ['fab', 'vuejs'], name: 'vue', isIcon: true },
      { icon: ['fab', 'js'], name: 'js', isIcon: true },
      { name: 'tailwindcss', isIcon: false, image: 'tailwindcss.png' },
    ],
    description: 'platziexc',
  },
  {
    id: 15,
    title: 'Simon says',
    url: 'https://javarcast.github.io/simon-dice/',
    image: 'simonsays.png',
    icons: [
      { icon: ['fab', 'html5'], name: 'html5', isIcon: true },
      { icon: ['fab', 'js'], name: 'js', isIcon: true },
      { icon: ['fab', 'css3'], name: 'css3', isIcon: true },
    ],
    description: 'simonsays',
  },
  {
    id: 16,
    title: 'Hotdog Gourmet',
    url: 'https://hotdog-gourmet.netlify.app/',
    image: 'hotdog.png',
    icons: [
      { icon: ['fab', 'angular'], name: 'angular', isIcon: true },
    ],
    description: 'hotdoggourmet',
  },
  {
    id: 17,
    title: 'Smile Clinic',
    url: 'https://gestion-citas.herokuapp.com/',
    image: 'gestiondecitas.png',
    icons: [
      { icon: ['fab', 'vuejs'], name: 'vue', isIcon: true },
      { icon: ['fab', 'laravel'], name: 'laravel', isIcon: true },
      { name: 'tailwindcss', isIcon: false, image: 'tailwindcss.png' },
    ],
    description: 'smilec',
  },
  {
    id: 18,
    title: 'Hangman Game',
    url: '#',
    image: 'hangman.png',
    icons: [
      { icon: ['fab', 'python'], name: 'python', isIcon: true },
    ],
    description: 'hangmang',
  },
  {
    id: 19,
    title: 'Note generator',
    url: 'https://generador-de-notas.netlify.app/',
    image: 'generadordenotas.png',
    icons: [
      { icon: ['fab', 'vuejs'], name: 'vue', isIcon: true },
    ],
    description: 'Application to generate Notes',
  },
  {
    id: 20,
    title: 'Shopping Cart',
    url: 'https://cart-simulate.netlify.app/',
    image: 'carritodecompras.png',
    icons: [
      { icon: ['fab', 'vuejs'], name: 'vue', isIcon: true },
    ],
    description: 'shoppingcart',
  },
  {
    id: 21,
    title: 'Contact Directory',
    url: '#',
    image: 'directoriocontactos.png',
    icons: [
      { icon: ['fab', 'python'], name: 'python', isIcon: true },
    ],
    description: 'contactd',
  },
  {
    id: 22,
    title: 'LosVega Decoraciones',
    url: 'https://losvegasdecoracion.com/',
    image: 'losvega.png',
    icons: [
      { icon: ['fab', 'wordpress'], name: 'wordpress', isIcon: true },
      { icon: ['fab', 'php'], name: 'php', isIcon: true },
    ],
    description: 'losvega',
  },

];
const references = [
  {
    name: 'Elena Gil Pascual',
    time: 'more a 1 Year',
    email: 'elenagilpascual@gmail.com',
    bussiness: 'EDV & RZS',
  },
  {
    name: 'Javier Gracia',
    time: '2 Years',
    email: 'javier.gracia@honimunn.com',
    bussiness: 'Performanze C.A.',
  },
  {
    name: 'Juan Gracia',
    time: '2 Years',
    email: 'juan.gracia@performanze.io',
    bussiness: ' Resultalia C.A., Performanze C.A.',
  },
];

const skills = [
  {
    icon: ['fab', 'wordpress'],
    name: 'wordpress',
    isIcon: true,
  },
  {
    icon: ['fab', 'vuejs'],
    name: 'vue',
    isIcon: true,
  },
  {
    icon: ['fab', 'laravel'],
    name: 'laravel',
    isIcon: true,
  },

  {
    icon: ['fab', 'php'],
    name: 'php',
    isIcon: true,
  },

  {
    icon: ['fab', 'js'],
    name: 'js',
    isIcon: true,
  },
  {
    icon: ['fab', 'html5'],
    name: 'html5',
    isIcon: true,
  },
  {
    icon: ['fab', 'css3'],
    name: 'css3',
    isIcon: true,
  },
  {
    icon: ['fab', 'python'],
    name: 'python',
    isIcon: true,
  },
  {
    icon: ['fab', 'bootstrap'],
    name: 'bootstrap',
    isIcon: true,
  },
  {
    icon: ['fab', 'cpanel'],
    name: 'cpanel',
    isIcon: true,
  },
  {
    icon: ['fab', 'jira'],
    name: 'jira',
    isIcon: true,
  },
  {
    icon: ['fab', 'trello'],
    name: 'trello',
    isIcon: true,
  },
  {
    icon: ['fab', 'linode'],
    name: 'linode',
    isIcon: true,
  },
  {
    icon: ['fab', 'git'],
    name: 'git',
    isIcon: true,
  },
  {
    icon: ['fab', 'elementor'],
    name: 'elementor',
    isIcon: true,
  },
  {
    icon: [],
    name: 'tailwindcss',
    isIcon: false,
    image: 'tailwindcss.png',
  },

];
export {
  works,
  references,
  skills,
};
